import React from 'react';
import { useTranslation } from 'react-i18next';

export const TranslatedDuration = ({ minutes }: { minutes: number }) => {
    const { t } = useTranslation('circles');

    return <>{t('shared.duration', { minutes })}</>;
};
